<template>
  <b-card class="bg-white rounded-xl px-2">
    <AddAnnouncementPopup :isOpen="isPopupOpen" @close="togglePopup" />
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Announcement</h2>
      </div>

      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="handleAdd"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
          Announcement</span
        >
      </base-button>
    </div>
    <AnnouncementTable />
  </b-card>
</template>

<script>
import AnnouncementTable from "./components/AnnouncementTable.vue";
import AddAnnouncementPopup from "./components/AddAnnouncementPopup.vue";

export default {
  data() {
    return {
      isPopupOpen: false,
    };
  },
  components: {
    AnnouncementTable,
    AddAnnouncementPopup,
  },
  methods: {
    handleAdd() {
      this.$router.push({ name: "addannouncementcontent" });
    },
    async togglePopup(val = false) {
      this.isPopupOpen = val;
    },
  },
};
</script>
<style>
.txt-color {
  color: #4f0a4b;
}
</style>
